import { POST_CARGAR_SECTOR } from "../actions/dependenciaEmpleador";



const INITIAL_STATE = {
  postCargarSector: {
    loading: false,
    error: false,
    data: {},
  }
}


const dependenciaEmpleador = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${POST_CARGAR_SECTOR}_PENDING`:
      return {
        ...state,
        postCargarSector: {
          ...state.postCargarSector,
          error: false,
          loading: true,
        },
      };
    case `${POST_CARGAR_SECTOR}_REJECTED`:
      return {
        ...state,
        postCargarSector: {
          ...state.postCargarSector,
          error: true,
          loading: false,
        },
      };
    case `${POST_CARGAR_SECTOR}_FULFILLED`:
      return {
        ...state,
        postCargarSector: {
          ...state.postCargarSector,
          error: false,
          loading: false,
          data: action.payload,
        },
      };
    default:
      return state;
  }
};


export default dependenciaEmpleador;